const emptyImageIfOverflowLocalstorage = (component,setOpenLocaleStoragePopUp) => {
    if(component.changed.src !== undefined){
        try { 
            localStorage.setItem("DATA", component.changed.src+component.changed.src);
        } catch(e) {
            setOpenLocaleStoragePopUp(true);
            component.set('src',"https://dummyimage.com/450x300/dee2e6/6c757d.jpg");
            
        }
        localStorage.removeItem("DATA");
    }
}

const emptyImageIfOverflowLocalstorageCreate = (component,setOpenLocaleStoragePopUp) => {
    if(component.attributes.type === 'image'){
        try { 
            localStorage.setItem("DATA", component.attributes.src+component.attributes.src);
        } catch(e) {
            setOpenLocaleStoragePopUp(true);
            component.set('src',"https://dummyimage.com/450x300/dee2e6/6c757d.jpg");
        }
        localStorage.removeItem("DATA");
    }
}

const findLocalStorageUsagePercentage = () => {

    const currentStorageSize = Math.round(JSON.stringify(localStorage).length / 1024);
    let maxStorageSize = 0;
    for (let i = 0, data = "m"; i < 140; i+1) {
    try { 
        localStorage.setItem("DATA", data);
        data += data;
    } catch(e) {
        maxStorageSize = Math.round(JSON.stringify(localStorage).length / 1024);
        break;
        }
    }
    localStorage.removeItem("DATA");
    
    return [(currentStorageSize / maxStorageSize).toFixed(4), currentStorageSize, maxStorageSize];

}

const updateLocalStorageUsageStats = () => {
    const modalContainer = document.getElementsByClassName('gjs-asset-manager')[0];
    if(document.getElementsByClassName('gjs-marginBottom')[0]){
        document.getElementsByClassName('gjs-marginBottom')[0].remove();
    }
    const localStorageUsegePercentage = document.createElement('div');
    const localStorageUsage = findLocalStorageUsagePercentage();
    const valueOfPercentage = document.createTextNode(`Percentage of localstorage usage : ${(localStorageUsage[0]*100).toFixed(2)} %,  Localstorage usage: ${localStorageUsage[1]} kB, Total provided localstorage size: ${localStorageUsage[2]} kB`);
    localStorageUsegePercentage.append(valueOfPercentage); 
    localStorageUsegePercentage.classList.add('gjs-marginBottom');
    
    modalContainer.insertBefore(localStorageUsegePercentage, modalContainer.firstChild);
}



const handleModals = (editor, setOpenLocaleStoragePopUp) => {

    editor.on("run:open-assets", (asset) => {

        if(asset.title === 'Select Image'){
            updateLocalStorageUsageStats();
        }

    })

    editor.on('component:update', (component) => {
        if(editor.Commands.isActive('enable-navigate-page') === false){
            emptyImageIfOverflowLocalstorage(component,setOpenLocaleStoragePopUp);
        }
    })

    editor.on('component:add', (component) => {
        if(editor.Commands.isActive('enable-navigate-page') === false){
            emptyImageIfOverflowLocalstorageCreate(component,setOpenLocaleStoragePopUp);
        }
    })

    editor.on('storage:store',() => {
        if(document.getElementsByClassName('gjs-marginBottom')[0]){
            updateLocalStorageUsageStats();
        }
    })

    editor.on('storage:start:store',() => {
        if(document.getElementsByClassName('gjs-marginBottom')[0]){
            updateLocalStorageUsageStats();
        }
    })
   
}

export default handleModals;
